import { Switch } from "@mui/material";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import {
  PROFILE_VISIBILITY_SWITCH_ID,
  ProfileVisibilityToggle,
} from "Components/Social/ProfileVisibilityToggle";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Social.PublicPermissions;

/**
 * Public/private profile switch of a CUSTOMER persona — business personas are always public
 * and never render it. Everything the switch decides hangs off the persona's user info, so this
 * only gates on it: until it is here, a disabled placeholder with the same footprint; after,
 * ProfileVisibilityToggle with the facts in hand.
 */
export const ProfileVisibilitySwitch = () => {
  const { t } = useResource();
  const { data: userInfo } = useUserInfoQuery();

  if (!userInfo) {
    return (
      <Switch
        size="small"
        checked={false}
        disabled
        slotProps={{
          input: {
            "aria-label": t(RESOURCES.PublicProfileLabel),
            id: PROFILE_VISIBILITY_SWITCH_ID,
          },
        }}
      />
    );
  }

  return (
    <ProfileVisibilityToggle
      isProfilePublic={userInfo.isProfilePublic}
      version={userInfo.version}
    />
  );
};
